import { combineReducers } from "redux";
import alertPageReducer from "./alertPage/alertPage.reducer";

import creditReducer from "./credit/credit.reducer";
import currentDriverReducer from "./currentDriver/currentDriver.reducer";
import currentReqReducer from "./currentReq/currentReq.reducer";
import loginReducer from "./login/login.reducer";
import mapReducer from "./map/map.reducer";
import newReuqestReducer from "./newRequest/newRequest.reducer";
import reqsReducer from "./reqs/reqs.reducer";
import userReducer from "./user/user.reducer";
import instantReqReducer from "./instantReq/instantReq.reducer";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import preReqReducer from "./preReq/preReq.reducer";

const rootReducer = combineReducers({
  user: userReducer,
  reqs: reqsReducer,
  credit: creditReducer,
  currentReq: currentReqReducer,
  currentDriver: currentDriverReducer,
  map: mapReducer,
  newReuqest: newReuqestReducer,
  login: loginReducer,
  alertPage: alertPageReducer,
  preReq: preReqReducer,
  instantReq: instantReqReducer,
});

const persistConfig = {
  key: "primary",
  storage: storage,
  // blacklist: ["currentReq", "reqs"],
  whitelist: ["user"],
};

export default persistReducer(persistConfig, rootReducer);
